import { ProductSubscribeGate } from "../../../products/subscribe_gate/ProductSubscribeGate";
import type { MembershipProduct, SpaceProfile } from "../SpaceType";
import { BundlePlanPurchaseActions } from "./BundlePlanPurchaseActions";
import { SpaceHomeMembershipSection } from "./SpaceHomeMembershipSection";

export function SpaceModuleSubscribeGate(props: {
  spaceId: string;
  row: MembershipProduct;
  membershipProducts: MembershipProduct[];
  isLoggedIn: boolean;
  onLoginRequest: () => void;
  spaceProfile: SpaceProfile | null;
}): JSX.Element {
  const { spaceId, row, membershipProducts, isLoggedIn, onLoginRequest, spaceProfile } = props;
  return (
    <ProductSubscribeGate row={row}>
      <div className="space-poster-subscribe-actions">
        <BundlePlanPurchaseActions
          spaceId={spaceId}
          row={row}
          membershipProducts={membershipProducts}
          isLoggedIn={isLoggedIn}
          onLoginRequest={onLoginRequest}
          spaceProfile={spaceProfile}
          variant="platform"
        />
        <SpaceHomeMembershipSection
          spaceId={spaceId}
          row={row}
          isLoggedIn={isLoggedIn}
          onLoginRequest={onLoginRequest}
          spaceProfile={spaceProfile}
          subscribeCtaLabel="订阅"
          subscribeCtaPresentation="button"
          subscribePrimaryButtonClassName="space-access-gate__subscribe-btn"
        />
      </div>
    </ProductSubscribeGate>
  );
}
